import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, User } from 'lucide-react';
import { articlesAPI } from '@/lib/api';

const ArticlesPage = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        const response = await articlesAPI.getAll();
        setArticles(response.data);
      } catch (error) {
        console.error('Failed to fetch articles:', error);
        setArticles([]);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><div className="text-[#D4AF37]">در حال بارگذاری...</div></div>;
  }

  return (
    <div className="min-h-screen py-12" data-testid="articles-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-light text-white mb-4" data-testid="page-title">مقالات و راهنماها</h1>
          <p className="text-zinc-400">آخرین اطلاعات مهاجرت، تحصیل و کار</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.id}
              to={`/articles/${article.id}`}
              data-testid={`article-card-${article.id}`}
              className="group glass-effect border border-white/10 rounded-2xl overflow-hidden hover:border-[#D4AF37]/30 transition-all hover:-translate-y-1 gold-glow-hover"
            >
              <img
                src={article.image_url}
                alt={article.title_fa}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-xs font-medium mb-3">
                  {article.category}
                </span>
                <h3 className="text-lg font-medium text-white mb-2 line-clamp-2 leading-relaxed">
                  {article.title_fa}
                </h3>
                <p className="text-sm text-zinc-400 line-clamp-2 leading-relaxed mb-4">
                  {article.excerpt_fa}
                </p>
                <div className="flex items-center justify-between pt-4 border-t border-white/10 text-xs text-zinc-500">
                  <div className="flex items-center gap-1">
                    <User size={14} />
                    <span>{article.author}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <Calendar size={14} />
                    <span>{new Date(article.published_date).toLocaleDateString('fa-IR')}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticlesPage;